import { render, staticRenderFns } from "./DeliveryMethods.vue?vue&type=template&id=42246fe5&"
import script from "./DeliveryMethods.vue?vue&type=script&lang=js&"
export * from "./DeliveryMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VCardText,VCardTitle,VRadio,VRadioGroup})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\eLpass\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42246fe5')) {
      api.createRecord('42246fe5', component.options)
    } else {
      api.reload('42246fe5', component.options)
    }
    module.hot.accept("./DeliveryMethods.vue?vue&type=template&id=42246fe5&", function () {
      api.rerender('42246fe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Checkout/DeliveryMethods.vue"
export default component.exports